import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IContactInfoDto } from '@/dtos';

import { formatClaimsProcessorPayload } from './ClaimsProcessors.types';

const useClaimsProcessorQuery = (id?: string, enabled?: boolean) => {
  const { isLoading, data } = useQuery(
    [API_URL.CONTACTS_BY_CONTACT_ID(id || ''), enabled],
    () => api.get<IContactInfoDto>(API_URL.CONTACTS_BY_CONTACT_ID(id || '')),
    { enabled: enabled && Boolean(id) }
  );

  const claimsProcessor = useMemo(() => {
    if (!data?.data) return undefined;

    return data?.data ? formatClaimsProcessorPayload(data?.data) : undefined;
  }, [data]);

  return {
    claimsProcessor,
    isLoading,
  };
};

export default useClaimsProcessorQuery;
